// extracted by mini-css-extract-plugin
export default {"dot":"TutorialBeacon-module__dot--jx6lu","pulse":"TutorialBeacon-module__pulse--wuyyr","bounceIn":"TutorialBeacon-module__bounceIn--wyBms"};